/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CBParentOrgModifiableAttribute { 
    /**
     * Carbon black parent org id
     */
    cb_parent_org_id?: number;
    /**
     * Carbon black pop id
     */
    cb_pop_id?: string;
    /**
     * Cbc url
     */
    cbc_url?: string;
    /**
     * Carbon black parent org super admin credentials path to AWS secret manager
     */
    login_credential_path?: string;
    /**
     * Carbon black org name
     */
    org_name?: string;
}

